<template>
  <button
    :type="type"
    :disabled="disabled || loading"
    :class="[
      'button',
      'button--large',
      'button--submit',
      'button--full-width',
      { 'button--loading': loading },
    ]"
  >
    <span class="button__label">{{ label }}</span>
    <span v-show="loading" class="button__spinner"></span>
  </button>
</template>

<script src="./submit.js"></script>
<style src="./submit.scss" lang="scss"></style>
